import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { ConectorProvider } from "../../providers/conector/conector";
import { GlobalProvider } from "../../providers/global/global";

@Component({
  selector: "page-documentos",
  templateUrl: "documentos.html",
})
export class DocumentosPage {
  documentos = [];
  data = {
    background: "assets/images/background/39.jpg",
  };
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private conector: ConectorProvider,
    private global: GlobalProvider
  ) {
    this.conector.getDocumentos().subscribe((data) => {
      console.log("documentos", data);
      this.documentos = data["documentos"];
    });

    let TextLOG = "Acceso Lista de DOCUMENTOS ";

    this.conector.registraractividad(TextLOG).subscribe((data) => {
      console.log("registramos Actividad", TextLOG);
    });
  }

  ionViewDidLoad() {}

  verDocumento(doc) {
    console.log("ver documento", doc);
    window.open(this.global.URLMEDIA + doc.documento, "_system");
  }
}



// WEBPACK FOOTER //
// ./src/pages/documentos/documentos.ts